import * as css from 'css/exports.module.scss';

import './PardotRule.scss';

import { ifClickHandler } from '@lib/events';
import { lowerFirst } from '@sonar-software/sonar-ts-lib';
import { SonarRecord } from '@ui/records';

import { Col, Row, Typography } from 'antd';
import { PeriscopePardotRule, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

export interface PardotRuleProps {
	entity: PeriscopePardotRule;
	onRuleClick: RuleClickHandler;
}

const { Title } = Typography;

export type RuleClickHandler = (rule: PeriscopePardotRule) => void;

export const PardotRule: React.FC<PardotRuleProps> = ({ entity, onRuleClick }) => {
	const { description, displayName, sonarObjectId, sonarObjectType } = entity;
	const ruleReferenceType = lowerFirst(entity.sonarObjectType) as SonarObjectType;
	const clickable = Boolean(sonarObjectType) && Boolean(sonarObjectId);

	const handleOnClick = useMemo(() => ifClickHandler(onRuleClick, entity), [ entity, onRuleClick ]);

	const formattedDisplayName = useMemo(() => {
		if (!displayName?.includes('\n')) {
			return displayName;
		}

		return displayName?.split('\n').map((entry) => {
			const [ title, value ] = entry.split(':');

			if (!value) {
				return title.trim();
			}

			const formattedTitle = `${title?.trim()}: `;

			return (
				<React.Fragment key={ entry }>
					<strong>{ formattedTitle }</strong>
					{ value }
					<br />
				</React.Fragment>
			);
		});
	}, [ displayName ]);

	return (
		<div className='pardot-rule'>
			<Row
				align='middle'
				gutter={ Number(css.size4) }
				justify='space-between'
				wrap={ false }>
				<Col flex='none'>
					<Title
						className='rule-label'
						level={ 4 }>
						{ description }
					</Title>
				</Col>
			</Row>
			<SonarRecord
				name={ formattedDisplayName }
				onClick={ clickable ? handleOnClick : undefined }
				sonarObjectId={ sonarObjectId }
				sonarObjectType={ ruleReferenceType } />
		</div>
	);
};
